import {WebInterfaceSdk} from "@byted/account-api-oversea";

export const accountSDK = new WebInterfaceSdk({
    aid: parseInt(process.env.VUE_APP_OLYMPUS_APP_ID),
    region: process.env.VUE_APP_OLYMPUS_APP_REGION,
    appName: process.env.VUE_APP_OLYMPUS_APP_NAME,
    appKey: process.env.VUE_APP_OLYMPUS_APP_KEY,
    printLog: process.env.VUE_APP_PASSPORT_SDK_ENV !== "prod",
    isBoe: process.env.VUE_APP_PASSPORT_SDK_ENV !== "prod",
    // isOversea: true,
});
